module.exports = __webpack_public_path__ + "static/media/cello.f87e31e8.svg";